import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"

import { priceChangesTableData, priceChangesSubmittedFilters, insightsData, insightsIsLoading, insightsIsOpen, insightsError } from "../@signals"


const MAX_ROWS = 50

export default function useInsights() {

	const handleGetInsights = useCallback(() => {
		const rows = priceChangesTableData.value
		const filters = priceChangesSubmittedFilters.value

		if (!rows.length) return

		insightsIsOpen.value = true
		insightsIsLoading.value = true
		insightsData.value = ""
		insightsError.value = null

		const payload = {
			dashboard: "pricing-changes",
			data: rows.slice(0, MAX_ROWS),
			filters: {
				country: filters.country,
				retailer: filters.retailer,
				prevSingleDate: filters.prevSingleDate,
				currentSingleDate: filters.currentSingleDate
			}
		}

		postSubmit("/api/ai-insights/analyze", payload)
			.then(res => {
				insightsData.value = res.insights
			})
			.catch(() => {
				insightsError.value = true
			})
			.finally(() => {
				insightsIsLoading.value = false
			})
	}, [])

	return { handleGetInsights }
}
